// src/actions/reports/getTopClientes.action.ts
import apiClient from "@/clients/apiClient";
import { ApiResponse } from "@/utils/ApiResponse";
import { ClienteTopComprasInterface } from "../interfaces/clienteTopCompras.interface";


export async function getTopClientesAction(
  limit: number 
): Promise<ApiResponse<ClienteTopComprasInterface>> {
  const { data } = await apiClient.get<ClienteTopComprasInterface>("reports/clientes/top", {
    params: { limit },
  });

  return {
    status: 200,
    data,
    message: "Top clientes obtenidos correctamente",
  };
}